import { inject, Pipe, PipeTransform } from '@angular/core';
import { format, formatRelative, Locale } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import { LanguageService } from '../services/language.service';

@Pipe({
  name: 'readableTime',
  standalone: true,
})
export class ReadableTimePipe implements PipeTransform {
  private languageService = inject(LanguageService);

  private locales: Record<string, Locale> = {
    en: enUS,
    fr: fr,
  };

  transform(value: string): string {
    const date = new Date(value);
    const localeCode = this.languageService.appLanguage()?.code ?? 'en';
    const locale = this.locales[localeCode] || enUS; // Default to English

    // Use formatRelative for human-readable timestamps
    return formatRelative(date, new Date(), { locale });
  }
}
